export const LANGUAGE_CODES = {
  English: 'en',
  German: 'de',
};

export const AVAILABLE_LANGUAGES = [
  'en',
  'de',
];
